class NavigationTabs extends window.BAO.CustomElement() {
  setupListeners () {
    this.tabs = this.els.tab?.elements && Array.from(this.els.tab.elements)
    this.panels = this.els.panel?.elements

    if (!this.tabs) return

    this.tabs.forEach(tab => {
      this.listeners.add(tab, 'click', this.handleTabClick.bind(this))
      this.listeners.add(tab, 'keydown', this.handleTabKeydown.bind(this))
    })
  }

  handleTabKeydown (e) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End']

    if (!keys.includes(e.key)) return

    e.preventDefault()

    const current = this.tabs.indexOf(e.currentTarget)
    const last = this.tabs.length - 1
    let next = current

    if (e.key === 'ArrowRight') next = current === last ? 0 : current + 1
    if (e.key === 'ArrowLeft') next = current === 0 ? last : current - 1
    if (e.key === 'Home') next = 0
    if (e.key === 'End') next = last

    this.tabs[next].focus()
    this.tabs[next].click()
  }

  handleTabClick (e) {
    const tab = e.target.closest(this.els.tab.selector)
    const id = tab.dataset.tabId
    const titleHandle = tab.dataset.titleHandle

    if (!id) return

    if (this.externalEls?.container?.element) {
      this.externalEls.container.element.scrollTo({
        top: 0,
        behavior: 'smooth',
      })

      this.externalEls.container.element.dataset.activeTabTitle = titleHandle
    }

    this.updateTabs(id)
    this.updatePanels(id)
  }

  updateTabs (id) {
    this.tabs.forEach(tab => {
      const isSelected = tab.dataset.tabId === id

      tab.setAttribute('aria-selected', isSelected)
      tab.setAttribute('tabindex', isSelected ? '0' : '-1')
    })
  }

  updatePanels (id) {
    this.panels.forEach(panel => {
      panel.setAttribute('aria-hidden', panel.dataset.panelId !== id)
    })
  }
}

if (!customElements.get('navigation-tabs')) {
  customElements.define('navigation-tabs', NavigationTabs)
}
